import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip';

const RupTooltip = styled(({ className, ...props }: TooltipProps) => (
	<Tooltip
		{...props}
		PopperProps={{
			sx: {
				'&[data-popper-reference-hidden]': {
					display: 'none',
					pointerEvents: 'none'
				},
				zIndex: 99999
			}
		}}
		classes={{ popper: className }}
	/>
))(() => ({
	[`& .${tooltipClasses.tooltip}`]: {
		backgroundColor: '#fff',
		color: '#131c24',
		padding: '0.25rem 0.5rem',
		borderRadius: '0.25rem',
		maxWidth: '37.5rem',
		lineHeight: '1.25rem',
		fontSize: '.875rem',
		fontWeight: '400',
		borderWidth: '0'
	},
	[`& .${tooltipClasses.arrow}`]: {
		borderColor: 'rgba(0,0,0,0)',
		borderBottomColor: '#fff',
		borderStyle: 'solid',
		color: '#fff'
	},
	[`&.${tooltipClasses.popper}`]: {
		filter: 'drop-shadow(0 2px 2px rgba(0, 0, 0, .14)) drop-shadow(0 0 3px rgba(0, 0, 0, .2))'
	}
}));

export default RupTooltip;
